import FileView from './components/Views/File';
export { FileView };
import SocialSharing from '@codesyntax/volto-social-sharing/SocialSharing';
import { DEFAULT_SOCIAL } from '@codesyntax/volto-social-sharing/defaultSettings';
import { faSquareXTwitter } from '@fortawesome/free-brands-svg-icons';
import { library } from '@fortawesome/fontawesome-svg-core';
import heroSVG from '@plone/volto/icons/hero.svg';
import cardsSVG from '@plone/volto/icons/cards.svg';
import iconSVG from '@plone/volto/icons/select-all.svg';
import sliderSVG from '@plone/volto/icons/slider.svg';
import { Edit as CustomHeroEdit, View as CustomHeroView} from './components/Blocks/CustomHero';
import { Edit as ButtonRowEdit, View as ButtonRowView} from './components/Blocks/ButtonRow';
import { Edit as MultiCardEdit, View as MultiCardView } from './components/Blocks/MultiCardBlock';
import { Edit as IconLinkRowEdit, View as IconLinkRowView} from './components/Blocks/IconLinkRow';
import { Edit as EmblaCarouselEdit, View as EmblaCarouselView} from './components/Blocks/EmblaCarousel';

library.add(faSquareXTwitter);

//social sharing


const applyConfig = (config) => {
  config.settings.isMultilingual = false;
  config.settings.supportedLanguages = ['en'];
  config.settings.defaultLanguage = 'en';
  config.blocks.themes = [
    {
      style: {
        '--theme-color': 'white',
        '--theme-high-contrast-color': 'var(--lightgrey)',
        '--theme-foreground-color': 'black',
        '--theme-low-contrast-foreground-color': 'var(--grey)',
      },
      name: 'default',
      label: 'Default',
    },
    {
      style: {
        '--theme-color': 'var(--lightgrey)',
        '--theme-high-contrast-color': 'black',
        '--theme-foreground-color': 'black',
        '--theme-low-contrast-foreground-color': 'var(--lightgrey)',
      },
      name: 'lightgrey',
      label: 'Light Grey',
    },
    {
      style: {
        '--theme-color': 'var(--green)',
        '--theme-high-contrast-color': 'white',
        '--theme-foreground-color': 'white',
        '--theme-low-contrast-foreground-color': 'var(--lightgrey)',
      },
      name: 'green',
      label: 'Green',
    },
  ];

  //Add additional volto-columns-block colours here

  config.blocks.blocksConfig.columnsBlock.available_colors = [
    // '#B80000',
    // '#DB3E00',
    // '#FCCB00',
    // '#008B02',
    // '#006B76',
    // '#1273DE',
    // '#004DCF',
    // '#5300EB',
    '#EFEFEF',
    '#EB9694',
    '#FAD0C3',
    '#FEF3BD',
    '#C1E1C5',
    '#BEDADC',
    '#C4DEF6',
    '#BED3F3',
    '#D4C4FB',
    '#2ab370',
    '#000000',
  ];
  //File views
  config.views = {
    ...config.views,
    contentTypesViews: {
      File: FileView,
    },
  };

  //enable volto-slider-block autoplay
  config.blocks.blocksConfig.slider.enableAutoPlay = true;

  //CustomHero
  config.blocks.blocksConfig.customHero = {
    id: 'customHero',
    title: 'Hero Block',
    icon: heroSVG,
    group: 'common',
    view: CustomHeroView,
    edit: CustomHeroEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //ButtonRow
  config.blocks.blocksConfig.buttonRow = {
    id: 'buttonRow',
    title: 'Button Row',
    icon: cardsSVG,
    group: 'common',
    view: ButtonRowView,
    edit: ButtonRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //IconLinkRow
  config.blocks.blocksConfig.iconLinkRow = {
    id: 'iconLinkRow',
    title: 'Icon Link Row',
    icon: iconSVG,
    group: 'common',
    view: IconLinkRowView,
    edit: IconLinkRowEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Multicard Block
  config.blocks.blocksConfig.multiCard = {
    id: 'multiCard',
    title: 'Multi Card',
    icon: cardsSVG,
    group: 'common',
    view: MultiCardView,
    edit: MultiCardEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Embla Carousel
  config.blocks.blocksConfig.EmblaCarousel = {
    id: 'EmblaCarousel',
    title: 'Embla Carousel',
    icon: sliderSVG,
    group: 'common',
    view: EmblaCarouselView,
    edit: EmblaCarouselEdit,
    restricted: false,
    mostUsed: true,
    sidebarTab: 1,
  };

  //Volto Social Sharing
  DEFAULT_SOCIAL.push({
    name: "LinkedIn",
    fa_name: ["fab", "linkedin-in"],
    color: "#0a66c2",
    sharing_url: "https://www.linkedin.com/sharing/share-offsite/?url=",
    id: "li"
  });
  let twitter = DEFAULT_SOCIAL.find((social) => social.id === 'tw');
  if (twitter) {
    twitter.fa_name = faSquareXTwitter;
    twitter.color = 'black';
    twitter.sharing_url = "https://x.com/intent/tweet?text=Check%20this%20out:&url=";
  }
  config.settings.appExtras = [
    ...config.settings.appExtras,
    {
      match: {
        path: ['/**'],
        exact: false,
      },
      component: SocialSharing,
      props: {
        socialElements: DEFAULT_SOCIAL,
      },
    },
  ];

  return config;
};

export default applyConfig;
